import {
  Injectable,
  ApplicationRef,
  Injector,
  ViewContainerRef,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertMessageComponent } from '../../components/alert-message/alert-message.component';
import { ConfirmationComponentComponent } from '../../components/confirmation-component/confirmation-component.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { ComponentRef } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root',
})
export class GenericService {
  private num = 1;

  public minimizeSidebar = new BehaviorSubject<boolean>(false);
  public minimizeSidebarState$ = this.minimizeSidebar.asObservable();

  private generatePdfSubject = new BehaviorSubject<any>(null);
  // generatePdf$ = this.generatePdfSubject.asObservable();

  private loader = new BehaviorSubject<boolean>(false);
  public loaderState = this.loader.asObservable();

  public deskCount = new BehaviorSubject<number>(0);
  public deskCount$ = this.deskCount.asObservable();

  public expenseDeskCount = new BehaviorSubject<number>(0);
  public expenseDeskCount$ = this.expenseDeskCount.asObservable();

  public msg: string | undefined = '';

  constructor(
    private dialog: MatDialog,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  hideLoader() {
    this.loader.next(false);
    this.msg = '';
  }

  showLoader(msg?: string) {
    this.loader.next(true);
    this.msg = msg;
  }

  showMessage(
    type: 'success' | 'warning' | 'error' | 'info',

    message: string | any,
    header?: string
  ) {
    const dialogRef = this.dialog.open(AlertMessageComponent, {
      data: {
        message,
        type,
        header,
      },
      width: '400px',
    });

    dialogRef.afterOpened().subscribe({
      next: () => {
        // setTimeout(() => {
        //   dialogRef.close();
        // }, 5000);
      },
    });
  }

  showConfirmationMsg(
    body: string,
    header?: string,
    confirmBtnText?: string,
    cancelBtnText?: string
  ): Observable<boolean> {
    return this.dialog
      .open(ConfirmationComponentComponent, {
        width: '550px',
        // panelClass: 'fullscreen-dialog',
        data: {
          body,
          header,
          cancelBtnText,
          confirmBtnText,
        },
      })
      .afterClosed();
  }

  triggerPdfGeneration(data: any) {
    this.generatePdfSubject.next(data);
    console.log('PDF generation triggered with data:', data);
  }

  generateComponentPdf(
    component: any,
    data: any,
    viewContainerRef: ViewContainerRef
  ) {
    const componentRef: ComponentRef<any> =
      viewContainerRef.createComponent(component);
    componentRef.instance.data = data; // Pass the data to the component

    // Attach the component to the application
    this.appRef.attachView(componentRef.hostView);

    // Add the component to the DOM (hidden)
    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    // Generate the PDF from the component's rendered HTML
    html2canvas(domElem).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage({
        imageData: imgData,
        format: 'PNG',
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
      });
      pdf.save('generated.pdf');

      // Clean up the component and remove it from the DOM
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });
  }

  generatePDF2(root: string) {
    const data = document.getElementById(root);
    if (data) {
      html2canvas(data, {
        scale: 2, // Adjust the scale for quality/file size balance
        useCORS: true, // Handle cross-origin resources
      })
        .then((canvas) => {
          const imgWidth = 210; // Width of A4 in mm
          const pageHeight = 297; // Height of A4 in mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;

          const pdf = new jsPDF('p', 'mm', 'a4');
          let position = 0;

          // Convert canvas to JPEG for smaller file size
          const imgData = canvas.toDataURL('image/jpeg', 0.7);

          // Add the first image (first page)
          pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position = heightLeft - imgHeight + 2; // Reduce gap between pages by adjusting position
            pdf.addPage(); // Add a new page
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight); // Add the remaining part of the image
            heightLeft -= pageHeight;
          }

          // Save or open the PDF
          const pdfBlob = pdf.output('blob');
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl, '_blank');
        })
        .catch((error) => {
          console.error('Error generating PDF:', error);
        });
    } else {
      console.error('Element with id ' + root + ' not found.');
    }
  }

  async generatePDF(
    root: string,
    orientation: 'portrait' | 'landscape' = 'portrait'
  ) {
    const html2pdfModule = await import('html2pdf.js');
    const html2pdf = html2pdfModule.default;
    const element = document.getElementById(root);
    if (!element) {
      console.error('Element not found:', root);
      return;
    }
    const opt = {
      margin: [5, 5, 5, 5], // top, left, bottom, right (in mm)
      filename: 'budget-performance.pdf',
      image: { type: 'jpeg', quality: 1.0 },
      html2canvas: {
        scale: 2, // <-- Experiment with this. A value < 1.0 will shrink content.
        useCORS: true,
        logging: false,
        scrollY: 0,
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: orientation,
      },
      pagebreak: { mode: ['css'] },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .outputPdf('bloburl')
      .then((url: any) => {
        window.open(url, '_blank');
      })
      .catch((err: any) => console.error('PDF generation error:', err));

    this.hideLoader();
  }
}
